import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icon_12.png'


const _withScopeId = n => (_pushScopeId("data-v-8c2ba4c6"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "wh-14",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ml-8 fz-14 lh-36" }, "导出", -1))

import { ref, getCurrentInstance, watch } from 'vue';

	
export default /*#__PURE__*/_defineComponent({
  __name: 'ExportBtn',
  props: {
		data: {
			type: Object,
			default: function () {
				return {}
			}
		},
		text: {
			type: String,
			default: "导出"
		}
	},
  setup(__props) {

	const props = __props;

	watch(() => props.data.data, (n : any) => {
		list.value = n;
	});

	const { proxy } = getCurrentInstance() as any;
	const loading = ref(false);
	const list = ref([]);

	const ExportFile = () => {
		if (!props.data.api) {
			proxy.$message.error("api链接不能为空");
			return false;
		}
		console.log(props.data.data)
		if (props.data.data.length == 0 && props.data.export_type == 1) {
			proxy.$message.error(props.data.ErrorTips);
			return false;
		}
		if (loading.value) {
			return false;
		}
		loading.value = true;
		let ids : any = [];
		list.value.forEach((v : any) => {
			ids.push(v.id);
		});
		proxy.$api.tokenRequest({
			url: props.data.api,
			method: "POST",
			isLoading: '加载中...',
			data: {
				type: props.data.type,
				export_type: props.data.export_type,
				ids: ids,
				params: props.data.params || {},
			},
			success: (res : any) => {
				loading.value = false;
				let a : any = document.createElement('a');
				a.href = res.data;
				a.setAttribute('download', "导出模板");
				a.click();
				a = null;
			},
			fail: () => {
				loading.value = false;
			},
		});
	};

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_button, {
      class: "export-btn",
      plain: "",
      type: "primary",
      onClick: ExportFile
    }, {
      default: _withCtx(() => [
        _hoisted_1,
        _hoisted_2
      ]),
      _: 1
    })
  ]))
}
}

})